const StateClass = {
  VIEWING_SEATS: 'tn-syos--viewing-seats',
  CART_DETAILS_VISIBLE: 'tn-syos--cart-details-visible',
  FULL_SCREEN_ENABLED: 'tn-syos--full-screen-enabled',
  WITH_SEATS_SELECTED: 'tn-syos--seats-selected',
  LEGEND_DETAILS_VISIBLE: 'tn-syos--legend-details-visible',
};


// exposed at window.tnew.syos.config:
export default {
  cartPath: '/cart/details',
  mobileMediaQuery: '(max-width: 767px)',
  tabletMediaQuery: '(max-width: 991px)',
  bestAvailableBasePath: '', // /events/detail/{prodSeasonNo}/{perfNo}
  fullScreenMaxWidth: 767, // Set to 0 to disable fullscreen
  isLegendExpandedByDefault: false,
  screenButtonShouldDisplayPricetypeDescription: false,
  priceRangeIncludesAllPricetypes: true,
  screenButtonShouldRenderPriceRange: true,
  legendShouldRenderPriceRange: true,
  legendShouldRenderPricetypeList: true,
  priceTypeSortOrder: 'PriceDescending',
  pricing: {
    isFeeDisclaimerVisible: true,
    feeDisclaimers: {},
  },
  api: {
    requestTimeout: 30000, // in milliseconds
    basePath: '/api/syos/',
    useCachedData: false, // For debug/development only
  },
  seatView: {
    drawTransformOrigin: false,
    drawMargins: false,
    renderNonSeats: true,
  },
};

export {
  StateClass,
};



// WEBPACK FOOTER //
// ./src/syos/SyosGlobalConfig.js